import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '../Components/Typography';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined';
import FolderSpecialOutlinedIcon from '@mui/icons-material/FolderSpecialOutlined';

const item: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	px: 5,
};

export const ProductFeatures = () => {
	return (
		<Box
			component="section"
			sx={{
				display: 'flex',
				overflow: 'hidden',
				bgcolor: 'secondary.light',
				mb: 4,
			}}
			id="features"
		>
			<Container
				sx={{
					mt: 10,
					mb: 10,
					position: 'relative',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				<Typography
					variant="h4"
					marked="center"
					align="center"
					component="h2"
					paddingBottom={5}
				>
					Product Features
				</Typography>
				<Box
					component="img"
					src="/static/themes/onepirate/productCurvyLines.png"
					alt="curvy lines"
					sx={{
						pointerEvents: 'none',
						position: 'absolute',
						top: -180,
					}}
				/>
				<Grid container spacing={5}>
					<Grid item xs={12} md={4}>
						<Box sx={item}>
							<FolderSpecialOutlinedIcon sx={{ fontSize: 70 }} />
							<Typography variant="h6" sx={{ my: 5 }}>
								The best luxury hotels
							</Typography>
							<Typography variant="h5">
								{
									'From the latest trendy boutique hotel to the iconic palace with XXL pool'
								}
								{
									', go for a mini-vacation just a few subway stops away from your home.'
								}
							</Typography>
						</Box>
					</Grid>
					<Grid item xs={12} md={4}>
						<Box sx={item}>
							<TipsAndUpdatesOutlinedIcon sx={{ fontSize: 70 }} />
							<Typography variant="h6" sx={{ my: 5 }}>
								New experiences
							</Typography>
							<Typography variant="h5">
								{
									'Privatize a pool, take a Japanese bath or wake up in 900m2 of garden… '
								}
								{'your Sundays will not be alike.'}
							</Typography>
						</Box>
					</Grid>
					<Grid item xs={12} md={4}>
						<Box sx={item}>
							<AccountBalanceWalletOutlinedIcon
								sx={{ fontSize: 70 }}
							/>
							<Typography variant="h6" sx={{ my: 5 }}>
								Exclusive rates
							</Typography>
							<Typography variant="h5">
								{
									'By registering, you will access specially negotiated rates '
								}
								{'that you will not find anywhere else.'}
							</Typography>
						</Box>
					</Grid>
				</Grid>
			</Container>
		</Box>
	);
};
